var _excluded = ["breakpoint", "children", "className", "flyout", "id", "innerRef", "isControlled", "isDisabled", "isReadonly", "isOpen", "messages", "modalClassName"];
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import * as React from 'react';
import React__default, { PureComponent, createRef, cloneElement, isValidElement, useState, useEffect } from 'react';
import * as ReactDOM from 'react-dom';
import { createPopper } from '@popperjs/core';
import { ButtonWithIcon, Button } from '@els/els-react--button';
import { createEnum, makeErrorBoundComponent, generateId } from '@els/els-react--utils';
import classnames from 'classnames';
import PT from 'prop-types';
import { Modal } from '@els/els-react--modal';
var ManagerReferenceNodeContext = React.createContext();
var ManagerReferenceNodeSetterContext = React.createContext();
function Manager(_ref) {
  var children = _ref.children;
  var _React$useState = React.useState(null),
    referenceNode = _React$useState[0],
    setReferenceNode = _React$useState[1];
  var hasUnmounted = React.useRef(false);
  React.useEffect(function () {
    return function () {
      hasUnmounted.current = true;
    };
  }, []);
  var handleSetReferenceNode = React.useCallback(function (node) {
    if (!hasUnmounted.current) {
      setReferenceNode(node);
    }
  }, []);
  return /*#__PURE__*/React.createElement(ManagerReferenceNodeContext.Provider, {
    value: referenceNode
  }, /*#__PURE__*/React.createElement(ManagerReferenceNodeSetterContext.Provider, {
    value: handleSetReferenceNode
  }, children));
}

/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === 'function') {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return fn.apply(void 0, args);
  }
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === 'function') {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
    ref.current = node;
  }
};
/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
      value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? React.useLayoutEffect : React.useEffect;
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.3
  if (a === b) return true;
  if (a && b && _typeof(a) == 'object' && _typeof(b) == 'object') {
    if (a.constructor !== b.constructor) return false;
    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;) if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && a instanceof Map && b instanceof Map) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done) if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done) if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }
    if (hasSet && a instanceof Set && b instanceof Set) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done) if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;) if (a[i] !== b[i]) return false;
      return true;
    }
    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    // START: Modifications:
    // Apply guards for `Object.create(null)` handling. See:
    // - https://github.com/FormidableLabs/react-fast-compare/issues/64
    // - https://github.com/epoberezkin/fast-deep-equal/issues/49
    if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
    // END: Modifications

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;
    for (i = length; i-- !== 0;) if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }
  return a !== a && b !== b;
}
// end fast-deep-equal

var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message || '').match(/stack|recursion/i)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};
var isEqual = /*@__PURE__*/getDefaultExportFromCjs(reactFastCompare);
var EMPTY_MODIFIERS$1 = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }
  var prevOptions = React.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS$1
  };
  var _React$useState = React.useState({
      styles: {
        popper: {
          position: optionsWithDefaults.strategy,
          left: '0',
          top: '0'
        },
        arrow: {
          position: 'absolute'
        }
      },
      attributes: {}
    }),
    state = _React$useState[0],
    setState = _React$useState[1];
  var updateStateModifier = React.useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        ReactDOM.flushSync(function () {
          setState({
            styles: fromEntries(elements.map(function (element) {
              return [element, state.styles[element] || {}];
            })),
            attributes: fromEntries(elements.map(function (element) {
              return [element, state.attributes[element]];
            }))
          });
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = React.useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };
    if (isEqual(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = React.useRef();
  useIsomorphicLayoutEffect(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }
    var createPopper$1 = options.createPopper || createPopper;
    var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};
var NOOP = function NOOP() {
  return void 0;
};
var NOOP_PROMISE = function NOOP_PROMISE() {
  return Promise.resolve(null);
};
var EMPTY_MODIFIERS = [];
function Popper(_ref) {
  var _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
    _ref$strategy = _ref.strategy,
    strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy,
    _ref$modifiers = _ref.modifiers,
    modifiers = _ref$modifiers === void 0 ? EMPTY_MODIFIERS : _ref$modifiers,
    referenceElement = _ref.referenceElement,
    onFirstUpdate = _ref.onFirstUpdate,
    innerRef = _ref.innerRef,
    children = _ref.children;
  var referenceNode = React.useContext(ManagerReferenceNodeContext);
  var _React$useState = React.useState(null),
    popperElement = _React$useState[0],
    setPopperElement = _React$useState[1];
  var _React$useState2 = React.useState(null),
    arrowElement = _React$useState2[0],
    setArrowElement = _React$useState2[1];
  React.useEffect(function () {
    setRef(innerRef, popperElement);
  }, [innerRef, popperElement]);
  var options = React.useMemo(function () {
    return {
      placement: placement,
      strategy: strategy,
      onFirstUpdate: onFirstUpdate,
      modifiers: [].concat(modifiers, [{
        name: 'arrow',
        enabled: arrowElement != null,
        options: {
          element: arrowElement
        }
      }])
    };
  }, [placement, strategy, onFirstUpdate, modifiers, arrowElement]);
  var _usePopper = usePopper(referenceElement || referenceNode, popperElement, options),
    state = _usePopper.state,
    styles = _usePopper.styles,
    forceUpdate = _usePopper.forceUpdate,
    update = _usePopper.update;
  var childrenProps = React.useMemo(function () {
    return {
      ref: setPopperElement,
      style: styles.popper,
      placement: state ? state.placement : placement,
      hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
      isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
      arrowProps: {
        style: styles.arrow,
        ref: setArrowElement
      },
      forceUpdate: forceUpdate || NOOP,
      update: update || NOOP_PROMISE
    };
  }, [setPopperElement, setArrowElement, placement, state, styles, update, forceUpdate]);
  return unwrapArray(children)(childrenProps);
}

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';
var warning = function warning() {};
if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
  warning = function warning(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}
var warning_1 = warning;
var warning$1 = /*@__PURE__*/getDefaultExportFromCjs(warning_1);
function Reference(_ref) {
  var children = _ref.children,
    innerRef = _ref.innerRef;
  var setReferenceNode = React.useContext(ManagerReferenceNodeSetterContext);
  var refHandler = React.useCallback(function (node) {
    setRef(innerRef, node);
    safeInvoke(setReferenceNode, node);
  }, [innerRef, setReferenceNode]); // ran on unmount
  // eslint-disable-next-line react-hooks/exhaustive-deps

  React.useEffect(function () {
    return function () {
      return setRef(innerRef, null);
    };
  }, []);
  React.useEffect(function () {
    warning$1(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
  }, [setReferenceNode]);
  return unwrapArray(children)({
    ref: refHandler
  });
}
var DefaultMessages = createEnum({
  closeModal: 'Close'
});
var FlyoutTriggers = createEnum(['click', 'hover']);
var FlyoutPlacements = createEnum(['bottom', 'top', 'right', 'left', 'bottom-start', 'top-start', 'right-start', 'left-start', 'bottom-end', 'top-end', 'right-end', 'left-end']);
var FlyoutThemes = createEnum(['default', 'minimal', 'simple', 'unstyled']);
var FlyoutPointerTypes = createEnum(['default', 'primary', 'secondary', 'positive', 'negative']);
var FlyoutAriaAttributes = createEnum(['none', 'expanded', 'haspopup']);
var arrayOf = PT.arrayOf,
  bool = PT.bool,
  func = PT.func,
  node = PT.node,
  object = PT.object,
  oneOfType = PT.oneOfType,
  string = PT.string;
var Flyout = /*#__PURE__*/function (_PureComponent) {
  function Flyout(props) {
    var _this;
    _classCallCheck(this, Flyout);
    _this = _callSuper(this, Flyout, [props]);
    // Users may provide partial `messages` props, and we fall back to the defaults for the other terms
    _defineProperty(_this, "compiledMessages", _objectSpread(_objectSpread({}, DefaultMessages), _this.props.messages));
    _defineProperty(_this, "schedulePopperUpdate", null);
    _defineProperty(_this, "applyEventListeners", function (shouldListen) {
      var _this$props = _this.props,
        trigger = _this$props.trigger,
        shouldCloseOnESC = _this$props.shouldCloseOnESC;
      if (shouldListen && shouldCloseOnESC) {
        document.addEventListener("keyup", _this.onKeyUpHandler, false);
      } else {
        document.removeEventListener("keyup", _this.onKeyUpHandler, false);
      }
      if (trigger === FlyoutTriggers.HOVER) {
        var hoverEvents = ["focusin", "focusout", "mouseenter", "mouseleave"];
        if (shouldListen) {
          hoverEvents.forEach(function (eventType) {
            return _this.selfRef.current.addEventListener(eventType, _this.onTrigger, false);
          });
        } else {
          hoverEvents.forEach(function (eventType) {
            return _this.selfRef.current.removeEventListener(eventType, _this.onTrigger, false);
          });
        }
      }
      if (trigger === FlyoutTriggers.CLICK) {
        var _this$sourceRef, _this$sourceRef2;
        var action = shouldListen ? (_this$sourceRef = _this.sourceRef) === null || _this$sourceRef === void 0 ? void 0 : _this$sourceRef.addEventListener : (_this$sourceRef2 = _this.sourceRef) === null || _this$sourceRef2 === void 0 ? void 0 : _this$sourceRef2.removeEventListener;
        action.call(_this.sourceRef, "click", _this.onTrigger, false);
        if (shouldListen) {
          document.addEventListener("mousedown", _this.onClickOutside.bind(_this));
          document.addEventListener("keydown", _this.onClickOutside.bind(_this));
        } else {
          document.removeEventListener("mousedown", _this.onClickOutside.bind(_this));
          document.removeEventListener("keydown", _this.onClickOutside.bind(_this));
        }
      }
    });
    _defineProperty(_this, "applyResizeEventListener", function (shouldListen) {
      if (typeof window !== "undefined") {
        if (shouldListen) {
          window.addEventListener("resize", _this.update.bind(_this));
        } else {
          window.removeEventListener("resize", _this.update.bind(_this));
        }
      } else {
        console.log("Resize event not applied. Global window object not found.");
      }
    });
    _defineProperty(_this, "isVisible", function () {
      return _this.props.isControlled ? _this.props.isOpen : _this.state.isVisible;
    });
    _defineProperty(_this, "toggleVisibility", function (isVisible) {
      _this.setState({
        isVisible: isVisible
      });
      _this.applyResizeEventListener(isVisible);
    });
    _defineProperty(_this, "onKeyUpHandler", function (event) {
      var shouldCloseOnESC = _this.props.shouldCloseOnESC;
      if (shouldCloseOnESC && (event.key === "Escape" || event.key === "Esc")) {
        if (_this.selfRef.current.contains(event.target)) {
          var _this$selfRef$current;
          (_this$selfRef$current = _this.selfRef.current.querySelector("button, a, input")) === null || _this$selfRef$current === void 0 || _this$selfRef$current.focus();
        }
        _this.toggleVisibility(false);
      }
    });
    _defineProperty(_this, "onTrigger", function (event) {
      var isVisible = _this.state.isVisible;
      var _this$props2 = _this.props,
        isDisabled = _this$props2.isDisabled,
        isReadOnly = _this$props2.isReadOnly;
      var type = event.type;
      if (isDisabled || isReadOnly) {
        return;
      }
      switch (type) {
        case "focusout":
        case "mouseleave":
          {
            isVisible = false;
            break;
          }
        case "focusin":
        case "mouseenter":
          {
            isVisible = true;
            break;
          }
        case "click":
        default:
          {
            isVisible = !isVisible;
            break;
          }
      }
      _this.toggleVisibility(isVisible);
    });
    _defineProperty(_this, "onClickOutside", function (event) {
      var isActionEvent = event.type === "mousedown" || event.key === "Enter" || event.key === "Space";
      if (isActionEvent && _this.isVisible() && _this.selfRef.current && !_this.selfRef.current.contains(event.target)) {
        _this.toggleVisibility(false);
      }
    });
    // This sets a ref to the flyout we attach the open close events to
    _defineProperty(_this, "setSourceRef", function (elNode) {
      _this.sourceRef = elNode;
      return elNode;
    });
    _this.state = {
      isVisible: _this.props.isControlled ? null : false,
      id: props.id || "".concat(generateId(), "-flyout")
    };
    _this.sourceRef = null;
    _this.selfRef = createRef();
    return _this;
  }
  _inherits(Flyout, _PureComponent);
  return _createClass(Flyout, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var shouldListen = true;
      this.applyEventListeners(shouldListen);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var oldIsVisible = prevState.isVisible;
      var isVisible = this.state.isVisible;
      var onToggle = this.props.onToggle;
      if (oldIsVisible !== isVisible) {
        onToggle(isVisible);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var shouldListen = false;
      this.applyEventListeners(shouldListen);
    }
  }, {
    key: "update",
    value:
    // update method is used to update the position of the flyout
    // schedulePopperUpdate method is a reference of popper's update method
    function update() {
      this.schedulePopperUpdate();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        ariaAttribute = _this$props3.ariaAttribute,
        className = _this$props3.className,
        children = _this$props3.children,
        flyout = _this$props3.flyout,
        noInternalPadding = _this$props3.noInternalPadding,
        maxHeight = _this$props3.maxHeight,
        modifiers = _this$props3.modifiers,
        popperPlacement = _this$props3.placement,
        pointer = _this$props3.pointer,
        pointerType = _this$props3.pointerType,
        showCloseButton = _this$props3.showCloseButton,
        showCloseButtonLabel = _this$props3.showCloseButtonLabel,
        theme = _this$props3.theme,
        trigger = _this$props3.trigger,
        width = _this$props3.width;
      var isVisible = this.isVisible();
      var ariaPropSetter = function ariaPropSetter(childrenToCheck) {
        var ariaAttributesToApply = null;
        switch (ariaAttribute) {
          case FlyoutAriaAttributes.EXPANDED:
            ariaAttributesToApply = {
              "aria-expanded": isVisible,
              "aria-controls": "".concat(_this2.state.id, "-flyout-pane")
            };
            break;
          case FlyoutAriaAttributes.HASPOPUP:
            ariaAttributesToApply = {
              "aria-haspopup": "dialog"
            };
            break;
        }
        if (Array.isArray(childrenToCheck)) {
          return React__default.Children.map(childrenToCheck, function (child) {
            if (child.type === "button" || child.type === "a" || child.type === "input") {
              return cloneElement(child, ariaAttributesToApply);
            }
            return child;
          });
        }
        if (isValidElement(childrenToCheck)) {
          return cloneElement(childrenToCheck, ariaAttributesToApply);
        }
        return childrenToCheck;
      };
      return /* @__PURE__ */React__default.createElement("div", {
        className: className,
        ref: this.selfRef,
        id: this.state.id,
        "data-testid": "flyout-hide"
      }, /* @__PURE__ */React__default.createElement(Manager, null, /* @__PURE__ */React__default.createElement(Reference, null, function (_ref2) {
        var ref = _ref2.ref;
        return (
          // Extra div here to provide our ref for events, separate from Popper's own ref.
          // Putting both on a single div (using an inline function) triggers rerenders when opening and closing
          /* @__PURE__ */
          React__default.createElement("div", {
            ref: _this2.setSourceRef,
            className: "c-els-flyout__reference-wrapper"
          }, /* @__PURE__ */React__default.createElement("div", {
            className: "c-els-flyout__reference",
            ref: ref,
            "data-testid": "flyout-reference"
          }, ariaPropSetter(children)))
        );
      }), /* @__PURE__ */React__default.createElement(Popper, {
        placement: popperPlacement,
        modifiers: modifiers
      }, function (_ref3) {
        var ref = _ref3.ref,
          style = _ref3.style,
          update = _ref3.update,
          placement = _ref3.placement;
        _this2.schedulePopperUpdate = update;
        var inlineStyles = _objectSpread(_objectSpread({}, style), {}, {
          width: width
        });
        var flyoutClassNames = classnames("c-els-flyout", {
          "c-els-flyout--primary": pointerType === FlyoutPointerTypes.PRIMARY
        }, {
          "c-els-flyout--secondary": pointerType === FlyoutPointerTypes.SECONDARY
        }, {
          "c-els-flyout--positive": pointerType === FlyoutPointerTypes.POSITIVE
        }, {
          "c-els-flyout--negative": pointerType === FlyoutPointerTypes.NEGATIVE
        }, {
          "c-els-flyout--top-right": pointer && placement === FlyoutPlacements.BOTTOM_END
        }, {
          "c-els-flyout--top-left": pointer && placement === FlyoutPlacements.BOTTOM_START
        }, {
          "c-els-flyout--bottom-right": pointer && placement === FlyoutPlacements.TOP_END
        }, {
          "c-els-flyout--bottom-left": pointer && placement === FlyoutPlacements.TOP_START
        }, {
          "c-els-flyout--simple": theme === FlyoutThemes.SIMPLE
        }, {
          "c-els-flyout--hover-trigger": trigger === "hover"
        }, {
          "c-els-flyout--no-internal-padding": noInternalPadding
        });
        var needsContainerDiv = theme === FlyoutThemes.DEFAULT || theme === FlyoutThemes.SIMPLE;
        var closeButton = showCloseButton && /* @__PURE__ */React__default.createElement(ButtonWithIcon, {
          sprite: "Close",
          type: "link",
          onClick: function onClick() {
            return _this2.toggleVisibility(false);
          },
          fallback: (/* istanbul ignore next */
          function fallback() {
            return "x";
          }),
          iconOnly: !showCloseButtonLabel,
          iconRight: true,
          className: "c-els-flyout__close-button"
        }, _this2.compiledMessages.CLOSE_MODAL);
        var heightStyles = {
          maxHeight: maxHeight,
          // Add scrolling behavior if a max-height is set
          overflowY: maxHeight ? "auto" : null
        };
        return _this2.isVisible() ? needsContainerDiv ? /* @__PURE__ */React__default.createElement("div", {
          id: "".concat(_this2.state.id, "-flyout-pane"),
          className: flyoutClassNames,
          style: inlineStyles,
          ref: ref,
          "data-placement": placement,
          "data-testid": "flyout-HDMS-container"
        }, /* @__PURE__ */React__default.createElement("div", {
          className: "c-els-flyout__pointer"
        }), /* @__PURE__ */React__default.createElement("div", {
          className: "c-els-flyout__window",
          style: heightStyles
        }, closeButton, flyout)) : /* @__PURE__ */React__default.createElement("div", {
          id: "".concat(_this2.state.id, "-flyout-pane"),
          className: theme === FlyoutThemes.MINIMAL ? "c-els-flyout-minimal" : "",
          style: heightStyles,
          ref: ref,
          "data-placement": placement,
          "data-testid": "flyout-container"
        }, closeButton, flyout) : null;
      })));
    }
  }]);
}(PureComponent);
Flyout.displayName = "Flyout";
Flyout.propTypes = {
  ariaAttribute: string,
  children: node,
  className: string,
  flyout: oneOfType([node, string]),
  id: string,
  isControlled: bool,
  isDisabled: bool,
  isOpen: bool,
  isReadOnly: bool,
  maxHeight: string,
  messages: object,
  // Full documentation available here: https://popper.js.org/docs/v2/modifiers/
  modifiers: arrayOf(object),
  noInternalPadding: bool,
  placement: string,
  pointer: bool,
  pointerType: string,
  shouldCloseOnESC: bool,
  showCloseButton: bool,
  showCloseButtonLabel: bool,
  theme: string,
  trigger: string,
  width: string,
  onToggle: func
};
Flyout.requiredProps = {};
Flyout.defaultProps = {
  ariaAttribute: FlyoutAriaAttributes.EXPANDED,
  children: null,
  className: "",
  flyout: null,
  id: null,
  isControlled: false,
  isDisabled: false,
  isOpen: false,
  isReadOnly: false,
  messages: DefaultMessages,
  modifiers: [],
  noInternalPadding: false,
  placement: FlyoutPlacements.BOTTOM,
  pointer: true,
  pointerType: FlyoutPointerTypes.DEFAULT,
  shouldCloseOnESC: false,
  showCloseButton: false,
  showCloseButtonLabel: false,
  theme: FlyoutThemes.DEFAULT,
  trigger: FlyoutTriggers.CLICK,
  maxHeight: null,
  width: null,
  onToggle: function onToggle() {}
};
Flyout.DefaultMessages = DefaultMessages;
Flyout.triggerTypes = FlyoutTriggers;
Flyout.placementTypes = FlyoutPlacements;
Flyout.themes = FlyoutThemes;
Flyout.pointerTypes = FlyoutPointerTypes;
Flyout.AriaAttributes = FlyoutAriaAttributes;
var RawFlyout = Flyout;
var Flyout$1 = makeErrorBoundComponent(RawFlyout);
var ResponsiveFlyout = function ResponsiveFlyout(props) {
  var breakpoint = props.breakpoint,
    children = props.children,
    className = props.className,
    flyout = props.flyout,
    id = props.id,
    innerRef = props.innerRef,
    isControlled = props.isControlled,
    isDisabled = props.isDisabled,
    isReadonly = props.isReadonly,
    isOpen = props.isOpen,
    messages = props.messages,
    modalClassName = props.modalClassName,
    flyoutProps = _objectWithoutProperties(props, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalOpen = _useState2[0],
    setModalOpen = _useState2[1];
  var _useState3 = useState(void 0),
    _useState4 = _slicedToArray(_useState3, 2),
    windowWidth = _useState4[0],
    setWindowWidth = _useState4[1];
  var compiledMessages = _objectSpread(_objectSpread({}, DefaultMessages), messages);
  useEffect(function () {
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, []);
  return windowWidth && windowWidth < breakpoint ? /* @__PURE__ */React__default.createElement(React__default.Fragment, null, /* @__PURE__ */React__default.createElement("div", {
    onClick: function onClick() {
      return !isDisabled && !isReadonly && setModalOpen(!modalOpen);
    },
    className: "".concat(className, " c-els-flyout__reference-wrapper"),
    id: id,
    "data-testid": "flyout-modal-trigger"
  }, /* @__PURE__ */React__default.createElement("div", {
    className: "c-els-flyout__reference"
  }, children)), (modalOpen || isControlled && isOpen) && /* @__PURE__ */React__default.createElement(Modal, {
    onClose: function onClose() {
      setModalOpen(false);
    },
    focusTrapProps: {
      active: true
    },
    fullPage: "page",
    messages: {
      CLOSE_MODAL: compiledMessages.CLOSE_MODAL
    },
    className: modalClassName
  }, /* @__PURE__ */React__default.createElement(React__default.Fragment, null, flyout, /* @__PURE__ */React__default.createElement("div", {
    className: "u-els-text-right u-els-margin-top"
  }, /* @__PURE__ */React__default.createElement(Button, {
    onClick: function onClick() {
      return setModalOpen(false);
    }
  }, compiledMessages.CLOSE_MODAL))))) : /* @__PURE__ */React__default.createElement(Flyout$1, _objectSpread({
    className: className,
    flyout: flyout,
    id: id,
    isControlled: isControlled,
    isDisabled: isDisabled,
    isOpen: isOpen,
    isReadonly: isReadonly,
    ref: innerRef
  }, flyoutProps), children);
};
ResponsiveFlyout.propTypes = _objectSpread(_objectSpread({}, Flyout$1.propTypes), {}, {
  breakpoint: PT.number,
  /** React ref that's passed to the flyout. Used by DatePicker to close the Flyout on selecting a date */
  innerRef: PT.object,
  /** Messages for internationalization */
  messages: PT.object,
  /** CSS class only applied when modal is used */
  modalClassName: PT.string
});
ResponsiveFlyout.requiredProps = _objectSpread({}, Flyout$1.requiredProps);
ResponsiveFlyout.defaultProps = _objectSpread(_objectSpread({}, Flyout$1.defaultProps), {}, {
  breakpoint: 600,
  messages: DefaultMessages,
  modalClassName: ""
});
ResponsiveFlyout.DefaultMessages = DefaultMessages;
var RawResponsiveFlyout = ResponsiveFlyout;
var ResponsiveFlyout$1 = makeErrorBoundComponent(RawResponsiveFlyout);
export { Flyout$1 as Flyout, RawFlyout, RawResponsiveFlyout, ResponsiveFlyout$1 as ResponsiveFlyout };
